import { ChangeDetectorRef, Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService, GlobalSearchService, StorageService } from 'src/services';
import { filter } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import moment from 'moment';
import { PipesModule } from 'src/services/pipes/pipes.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
declare function layout_change(args);
declare function layout_change_default();
import * as cc from 'currency-codes';
import getSymbolFromCurrency from 'currency-symbol-map';
import { TerminologyModule } from 'src/app/modules/terminology/terminology.module';
import { NavigationService } from 'src/services/navigation.service';

// window["cc"] = cc;
@Component({
  selector: 'app-header-layout',
  standalone: true,
  imports: [CommonModule, RouterLink, PipesModule, FormsModule, ReactiveFormsModule, TerminologyModule],
  templateUrl: './header-layout.component.html',
  styleUrl: './header-layout.component.scss'
})
export class HeaderLayoutComponent implements AfterViewInit {
  loggedIn = true;
  token;
  allNotifications = [];
  selectedYard: string = '';
  depotName;
  allYards = [];
  Object = Object;
  depotId;
  unreadNotificationCount = 0;
  defaultYard: any;
  yardArr = []
  exchangeRates: any = {};
  filteredExchangeRates: any = {};
  searchCurrency = "";

  @ViewChild('contentContainer') contentContainer!: ElementRef;
  searchTerm: string = '';
  activeComponent: string = '';
  searchResults: { name: string; component: string }[] = [];
  pages = [
    { name: 'Market Benchmarks', component: 'market benchmarks' },
    { name: 'Terminal Handling Charges', component: 'terminal handling charges' },
    { name: 'Geo-Hierarchy Methodology', component: 'geo-hierarchy methodology' },
    { name: 'Ocean Rate Methodology', component: 'ocean rate methodology' },
    { name: 'Contract Length', component: 'contract length' },
    { name: 'Market Metrics', component: 'market metrics' },
    { name: 'Contracted Within', component: 'contracted within' },
    { name: 'Container Types', component: 'container types' },
    { name: 'Future Rates', component: 'future rates' },
    { name: 'Coverage', component: 'coverage' },
    { name: 'Contract Validity', component: 'contract validity' }
  ];

  // filteredPages: any = this.pages; // Store filtered pages initially
  filteredPages: string[] = [];
  constructor(private navigationService: NavigationService,private cdr: ChangeDetectorRef, private service: AuthService, private router: Router, private searchService: GlobalSearchService, private storage: StorageService) {
    if (localStorage.getItem(environment.auth_token)) {
      this.service.getUserData({}).subscribe((res: any) => {
        if (res.success) {
          this.token = res.data;
        }
        else {
          return;
        }
      }, this.service.error)
    }
    else {
      return;
    }
  }

  ngOnInit() {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.url === '/home') {
          // this.getNotifications();
        }
      });
  }

  ngAfterViewInit() {
    this.searchService.searchQuery$.subscribe(query => {
      this.searchContent(query);
    });
  }

  searchContent(query: string) {
    if (!query) {
      this.searchResults = [];
      return;
    }

    this.searchResults = this.pages.filter(page => {
      const componentText = this.getComponentText();
      return componentText.includes(query);
    });

    if (this.searchResults.length > 0) {
      this.activeComponent = this.searchResults[0].component;
    }
  }

  getComponentText(): string {
    if (!this.contentContainer) return '';
    return this.contentContainer.nativeElement.innerText.toLowerCase();
  }

  onSearch(event: any) {
    const query = event.target.value.toLowerCase();
    //this.searchService.updateSearch(query);
    this.filteredPages = this.searchService.search(query);
  }

  searchQuery = '';

  navigateToPage(page: string) {
    // this.router.navigate([`/${page.toLowerCase().replace(/\s+/g, '-')}`]);
    this.storage.setData(page);
    this.navigationService.setActiveTerm(page);
    this.router.navigate(['/terminology']);
    this.filteredPages = [];
    this.searchQuery = '';
  }

  selectPage(page: any) {
    this.activeComponent = page.component; // Set the selected component
  }

  routePage() {
    this.router.navigate(['/setting']);
  }

  layoutChange(theme) {
    theme == 'default' ? layout_change_default() : layout_change(theme)
    localStorage.setItem('theme', theme)
    this.service.setDefaultTheme({ theme }).subscribe((res: any) => {
      if (res.success) {
        theme == 'default' ? layout_change_default() : layout_change(theme)
      }
      else {

      }
    })
  }

  getExchangeRates() {
    this.exchangeRates = {};
    this.service.getExchangeRates({ fromDate: moment().format("YYYY-MM-DD"), toDate: moment().format("YYYY-MM-DD") })
      .subscribe((res: any) => {
        if (res.success) {
          this.exchangeRates = res.data[0];
          this.filteredExchangeRates = res.data[0];
        }
        else {

        }
      })
  }

  filterExchangeRates() {
    const filteredRates = Object.entries(this.exchangeRates).filter(([key, value]) => {
      const currencyCode = key === 'alb' ? 'ALL' : key;
      return (
        currencyCode.toLowerCase().includes(this.searchCurrency.toLowerCase()) ||
        (this.getCurrency(currencyCode)?.currency || '').toLowerCase().includes(this.searchCurrency.toLowerCase())
      );
    });

    this.filteredExchangeRates = {};

    filteredRates.forEach(([key, value]) => {
      this.filteredExchangeRates[key] = value;
    })

    // return filteredRates;
  }

  getCurrency(code: string): any {
    if (code) {
      const currency = cc.code(code);
      if (currency) {
        return {
          code: currency.code.toUpperCase(),
          currency: currency.currency,
          digits: currency.digits,
          symbol: getSymbolFromCurrency(currency.code)
        };
      }
    }
    return { code: code ? code.toUpperCase() : code, currency: "" };
  }

  logout() {
    this.service.logout();
  }
}
